var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcloudSaveLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.056a3.57 3.57 0 00-1.393-2.874 3.22 3.22 0 01-1.719 1.464 3.128 3.128 0 001.75-2.789 3.177 3.177 0 00-3.224-3.136 2.13 2.13 0 00-.326.016c.377.836.585 1.739.61 2.656h-.048a7.735 7.735 0 00-15.3 0H4.3c.006-.904.198-1.798.563-2.625A5.475 5.475 0 000 10.252a5.632 5.632 0 005.708 5.554h14.517V15.8A3.799 3.799 0 0024 12.056z",
    fill: "#17BED0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.346 4.782a.375.375 0 01.375.375v3.375h2.096a.375.375 0 01.264.64l-3.594 3.595a.376.376 0 01-.531 0L8.362 9.17a.375.375 0 01.265-.639h2.094V5.157a.375.375 0 01.375-.375h2.25z",
    fill: "#fff"
  })));
}
export default SvgPcloudSaveLogo;